module.exports = __webpack_public_path__ + "img/jycj.8eda510c.png";